import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';

@Component({
  selector: 'app-demomenu',
  templateUrl: './demomenu.component.html',
  styleUrls: ['./demomenu.component.css']
})
export class DemomenuComponent implements OnInit {

  companyBO: any = {}
  groupColl: any = [];
  productColl: any = [];
  productgroupColl: any = [];

  selectgroup: any = ""
  searchtxt: any = ""

  isshowcategory: boolean = false

 // _urlname: any = ""
  //productid: number = 0;

  @Input() urlname=""

  @Output() menuChanged = new EventEmitter<any>();

  routerEventSubscription = Subscription.EMPTY;

  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal,
    private toastr: ToastrService, private cuurenctRoute: ActivatedRoute) {

  }

  ngOnInit() {
    this.fngetProduct()
  }

  ngOnDestroy(): void {

  


  }


  fnGetUrlParameters() {

  

  }

  fngetProduct() {
    var data = {
      'urlname': this.urlname,
    }
    this.appService.getProductDetailsByEmenu(data)
      .subscribe(
        (res) => {
          if (res.json().status == 200) {
            var result = res.json().result;
            if (result.length > 0) {
              if (result[0].length > 0) {
                this.companyBO = result[0][0]
              }
              this.groupColl = result[1];
              this.productColl = result[2];
              this.fnReloadProductList();

              if(this.companyBO.checkstatus!=="DONE"){
                this.menuChanged.emit(3)
              }
            }






            //console.log(this.productColl)
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }
        },
        (err) => {

          this.toastr.error('Error', err);
        })
  }

  fnReloadProductList() {


    this.productgroupColl = [];

    for (let gbo of this.groupColl) {
      let tempColl = []

      for (var pbo of this.productColl) {
        if (pbo.groupid === gbo.groupid) {
          tempColl.push(pbo);
        }
      }

      var abo = {
        groupid: gbo.groupid,
        groupname: gbo.groupname,
        productColl: tempColl
      }
      this.productgroupColl.push(abo)
    }

    if (this.productgroupColl.length > 0) {
      this.selectgroup = this.productgroupColl[0].groupname
    }

  }



  fnGroupBtnClick(groupname) {
    this.selectgroup = groupname;

    let el = document.getElementById(groupname);
    el.scrollIntoView({ block: "start", inline: "nearest" });

    this.isshowcategory = !this.isshowcategory

  }


  fnProductClick(abo) {

    // var deptid = abo.productid

    // const modalRef = this.productFindService.open(ProductdetailsComponent, { size: <any>'m', backdrop: 'static' });
    // modalRef.componentInstance.productid = deptid

    // modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    //   if (receivedEntry === 'CART') {
    //     this.menuChanged.emit("CART")
    //   }
    // });
  }



}